export default __webpack_public_path__ + "static/media/ge.bec3b631.svg";